import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SetupContainer } from '@/components/Containers/SetupContainer';
import { SIGNUP_BACKEND_URL } from '@/config';
import { EUR, LANG_ES } from '@/config/appConstants';
import { buildGTMAddToCartRequest, sendEventGtm } from '@/lib/gtm/gtmUtils';
import { iUserSetupData } from '@/types';

export type iSetupData = {
  formName: string;
  lang: string;
  hash: string;
  name: string;
  lastname: string;
  companyName: string;
  phone: string;
  email: string;
  token: string;
  tokeId: string;
  consentTerms: boolean;
  recaptcha: string;
};

export const SetupPublicPage = () => {
  const {
    hash = '',
    email = '',
    service = '',
    productname = '',
    productid = '',
    landingname = '',
    lang = LANG_ES,
  } = useParams();
  const { i18n } = useTranslation();
  const sendDataToGTM = useGTMDispatch();

  useEffect(() => {
    const userSetupData: iUserSetupData = {
      lang: LANG_ES,
      productName: productname,
      productId: productid,
      currency: EUR,
    };
    i18n.changeLanguage(lang);
    const GTMData = buildGTMAddToCartRequest(userSetupData);
    sendEventGtm(GTMData, sendDataToGTM);
  }, [i18n, lang, sendDataToGTM, productname, productid]);

  const getInitialValues = () => {
    return {
      formName: '',
      hash,
      email,
      name: '',
      lastname: '',
      companyName: '',
      phone: '',
      tokeId: '1',
      token: '',
      consentTerms: false,
      lang,
      recaptcha: '',
    };
  };

  const getSuccessRedirectURL = () => {
    return (
      `${SIGNUP_BACKEND_URL}` +
      `activation/` +
      `hash/${hash}` +
      `/service/${service}` +
      `/productname/${productname}` +
      `/productid/${productid}` +
      `/landingname/${landingname}` +
      `/lang/${i18n.language}`
    );
  };

  return (
    <div>
      <SetupContainer
        initialValues={getInitialValues()}
        successRedirectURL={getSuccessRedirectURL()}
      />
    </div>
  );
};
